// src/slices/index.js
import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// ✅ NEW team slice (Redux Toolkit)
import teamReducer from "../store/teamSlice";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  

  // ✅ add your RTK team slice under lowercase "team"
  team: teamReducer,

  
});

export default rootReducer;
